export const mediaUrl = 'https://cdn.truewebcart.com/'

export const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL || 'https://admin.truewebcart.co.uk/api/shop';

export const authPoints = [
    {title:'Faster checkout', subtitle:'Save your delivery details and reorder your regular lines in a couple of taps.'},
    {title:'Order history', subtitle:'See every past order, track what is on its way and repeat it in one click.'},
    {title:'Lowest Price in UK', subtitle:'Get the best prices in the UK, guaranteed on every order.'},
    {title:'Same-day dispatch', subtitle:'Order before 3pm and your account orders ship the same working day.'},
]